const emailSavedRowTypeEnum = Object.freeze({
  SAVED_ROW: 1,
  SYNCED_ROW: 2
})

export { emailSavedRowTypeEnum }



// WEBPACK FOOTER //
// ./src/modules/email-saved-rows/enum/EmailSavedRowTypeEnum.js